import {withLocalization} from '@epic-core/localization';
import {Slide} from 'epic-fortnite-react/components/carousel/types';
import React from 'react';

import VideoHeaderC2s6 from './VideoHeaderC2s6';

interface Props {
  slide: Slide;
  className?: string;
  getMessage: (code: string) => string;
}

const PrimalSlide = ({slide, className, getMessage}: Props) => {
  const {desktopImage, mobileImage} = slide.background;
  const {
    captionTitle,
    captionDesc,
    captionDesc2,
    captionImage,
    videoId,
    watchLabel,
    footerImage,
    footerText,
    seasonBug,
    button,
    captionPos,
  } = slide;

  const data = {
    logo: seasonBug,
    mobileLogo: seasonBug,
    badge: captionImage,
    bgImg: desktopImage,
    mobileBgImg: mobileImage,
    title: captionDesc,
    title2: captionTitle,
    title3: captionDesc,
    title4: captionDesc2,
    videoId,
    playText: watchLabel || getMessage('epic.fortnite.trailer'),
    footerLogo: footerImage,
    footerAlt: footerText,
    button,
    captionPos,
  };

  return <VideoHeaderC2s6 data={data} className={className || ''} />;
};

export default withLocalization(PrimalSlide);
